import React, { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./CustomModal.css";
import api from "../../seller-apis/api";

const SubmitAnswerModal = ({
  show,
  handleClose,
  data,
  refreshData,
  edit,
  answerIndex,
}) => {
  const [answer, setAnswer] = useState("");
  const [error, setError] = useState("");
  const submitAnswer = () => {
    if (answer == "") {
      setError("Answer cannot be empty!");
    } else {
      setError("");
      let postdata = {
        questionId: data._id,
        answer: answer,
      };

      api.QandA.answerQuestions(postdata).then((res) => {
        refreshData();
        handleClose();
        console.log(res);
      });
    }
  };
  return (
    <Modal
      className="custom-modal1 p-10"
      size="lg"
      centered
      show={show}
      onHide={handleClose}
    >
      <div class="header-pop p-3 mb-1">
        <div class="header-title">Submit your answer</div>
        <a class="close-pop" onClick={() => handleClose()}>
          ×
        </a>
      </div>
      <Modal.Body style={{ width: "100%" }}>
        <div className="mb-5">
          {/* <div className='prod-name'>{data.productId.productName}</div> */}
          <div className="question fs-12">
            <span className="fs-700 main-color">Q :</span> {data?.question}
          </div>
          {edit && (
            <div className="question fs-12">
              <span className="fs-700">Current Answer : </span>{data?.answers[answerIndex]?.answer}
            </div>
          )}
          <div className="answer my-3">
            <textarea
              onChange={(e) => setAnswer(e.target.value)}
              rows="4"
              className="profile-input w-100 p-2 gray-input"
              placeholder="Type new answer......."
            ></textarea>
            <div className="error">{error}</div>
          </div>
          <div className="text-center">
            <button
              className="apply-btn px-3 fs-12"
              onClick={() => submitAnswer()}
              disabled={!answer}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SubmitAnswerModal;
